import React, { useState } from "react";
import { FaGlobe, FaBook, FaSearch, FaWallet, FaBars, FaTimes } from "react-icons/fa";
import logo from "../assets/images/logo.webp";
import "./Navbar.css";
const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="logo-container">
          <img src={logo} alt="MenelikCoin Logo" className="logo" />
          <h1 className="title">MenelikCoin Roadmap</h1>
        </div>

        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          <li>
            <a href="https://menelik.cc/" target="_blank" rel="noopener noreferrer">
              <FaGlobe /> Website
            </a>
          </li>
          <li>
            <a href="https://docs.menelik.cc/" target="_blank" rel="noopener noreferrer">
              <FaBook /> Docs
            </a>
          </li>
          <li>
            <a href="https://explorer.menelik.cc/" target="_blank" rel="noopener noreferrer">
              <FaSearch /> Explorer
            </a>
          </li>
          <li>
            <a href="https://wallet.menelik.cc" target="_blank" rel="noopener noreferrer">
              <FaWallet /> Wallet
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
